import React, { useEffect } from "react";
import { PersonalInfoNoMemberFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const PersonalInfoNoMemberForm = ({
  isFormDisabled,
  initialValue,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    personal_email: yup.string().email().required("*Required"),
    personal_phone_number: yup
      .string()
      .required("*Required")
      .matches(phoneRegExp, "*Required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (initialValue) {
      reset({ ...initialValue });
    }
  }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps

  const { t } = useTranslation(["common", "form"]);

  return (
    <PersonalInfoNoMemberFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form_title">
          {t("Please enter contact details", { ns: "form" })}
        </div>
        <div className="input_wrap mb_32">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                isRequire
                label={t("Phone Number", { ns: "form" })}
                errors={errors.personal_phone_number?.message}
                disabled={isFormDisabled}
              />
            )}
            name="personal_phone_number"
            defaultValue=""
          />
          <div className="field_rec">
            {t(
              "Please enter your phone number to receive an OTP for verification.",
              { ns: "form" }
            )}
          </div>
        </div>
        <div className="input_wrap mb_32">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                isRequire
                label={t("Email (to receive the confirmation email.)", { ns: "form" })}
                errors={errors.personal_email?.message}
                disabled={isFormDisabled}
              />
            )}
            name="personal_email"
            defaultValue=""
          />
          <div className="field_rec">
            {t(
              "Please enter your email address so we can get back to you correctly.",
              { ns: "form" }
            )}
          </div>
        </div>
        <div className="warning_text">
          {t(
            "*Please review your information before confirming.",
            { ns: "form" }
          )}
        </div>
        <Buttons.BgStandard type="submit" label={t("Next", { ns: "common" })} />
      </form>
    </PersonalInfoNoMemberFormStyled>
  );
};

PersonalInfoNoMemberForm.propTypes = {};

export default PersonalInfoNoMemberForm;
